import { Link } from "react-router-dom";

const Minipost = ({ blogs }) => {
  return (
    <div className="">
      {blogs ? (
        <div className="row">
          {blogs.map((blog) => {
            return (
              <div
                className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 minipost"
                key={blog.id}
              >
                <div className="box">
                  <img src={blog.file.src} alt="" />
                  <div className="info">
                    <div className="top">
                      <h6 className="category-name">
                        <Link to="/">{blog.category}</Link>
                      </h6>
                      <h4 className="post-title">
                        <Link to={`blogs/${blog.id}`}>{blog.title}</Link>
                      </h4>
                    </div>
                    <div className="bot">
                      <h6 className="author-name">{blog.author}</h6>
                      <p className="date">
                        {Math.floor(blog.timeAgo / 1000 / 60 / 60 / 24) < 1
                          ? "اليوم"
                          : `منذ ${Math.floor(
                              blog.timeAgo / 1000 / 60 / 60 / 24
                            )} يوم`}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="row">
          <div className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 minipost">
            <div className="box skeleton-container">
              <div className="img skeleton"></div>
              <div className="info">
                <div className="top">
                  <h6 className="category-name">
                    <div className="skeleton w-100px"></div>
                  </h6>
                  <h4 className="post-title">
                    <div className="skeleton"></div>
                    <div className="skeleton"></div>
                  </h4>
                </div>
                <div className="bot">
                  <h6 className="author-name">
                    <div className="skeleton w-100px h-15px w-135px"></div>
                  </h6>
                  <div className="skeleton w-100px h-15px"></div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 minipost">
            <div className="box skeleton-container">
              <div className="img skeleton"></div>
              <div className="info">
                <div className="top">
                  <h6 className="category-name">
                    <div className="skeleton w-100px"></div>
                  </h6>
                  <h4 className="post-title">
                    <div className="skeleton"></div>
                    <div className="skeleton"></div>
                  </h4>
                </div>
                <div className="bot">
                  <h6 className="author-name">
                    <div className="skeleton w-100px h-15px w-135px"></div>
                  </h6>
                  <div className="skeleton w-100px h-15px"></div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 minipost">
            <div className="box skeleton-container">
              <div className="img skeleton"></div>
              <div className="info">
                <div className="top">
                  <h6 className="category-name">
                    <div className="skeleton w-100px"></div>
                  </h6>
                  <h4 className="post-title">
                    <div className="skeleton"></div>
                    <div className="skeleton"></div>
                  </h4>
                </div>
                <div className="bot">
                  <h6 className="author-name">
                    <div className="skeleton w-100px h-15px w-135px"></div>
                  </h6>
                  <div className="skeleton w-100px h-15px"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Minipost;
